<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <div class="flex h-full items-stretch gap-6">
    <div class="w-100">
      <app-form-control
        [withBottomMargin]="false"
        label="Zdjęcie główne">
        <app-multimedia-choose-or-upload-control
          [formControl]="form.controls.featuredFile" />
      </app-form-control>

      <app-form-control
        [withBottomMargin]="false"
        label="Galeria">
        <app-multimedia-choose-or-upload-multiple-control
          [formControl]="form.controls.files" />
      </app-form-control>
    </div>

    <div class="flex flex-1 flex-col bg-gray-50 p-6">
      <div>
        <app-form-control label="Nazwa">
          <input
            [formControl]="form.controls.name"
            appPrimengInputText
            pInputText
            placeholder="Wprowadź nazwę" />
        </app-form-control>

        <app-form-control label="Odpowiednik magazynowy">
          <p-select
            (onFilter)="handleWarehouseGoodSelectFilterChange($event)"
            [filter]="true"
            [formControl]="form.controls.warehouseProductId"
            [options]="valueOrDefault(warehouseGoodSelectItems$ | async, [])"
            appPrimengSelect
            [fluid]="true"
            placeholder="Wybierz powiązany produkt z magazynu" />

          <app-warehouse-good-usage-status
            [currentObjectType]="warehouseGoodType.Product"
            [currentObjectId]="data()?.id"
            [goodId]="currentGoodId$ | async" />
        </app-form-control>

        <app-form-control label="Marka kosmetyczna">
          <p-select
            [filter]="true"
            [formControl]="form.controls.cosmeticBrandId"
            [options]="valueOrDefault(brandSelectItems$ | async, [])"
            appPrimengSelect
            [fluid]="true"
            placeholder="Wybierz markę kosmetyczną" />
        </app-form-control>

        <app-form-control label="Cena">
          <p-input-number
            [fluid]="true"
            [formControl]="form.controls.price"
            [min]="0"
            currency="PLN"
            mode="currency"
            placeholder="Wprowadź cenę" />
        </app-form-control>

        <app-form-control label="Dostępna ilość do kupienia">
          <p-input-number
            [fluid]="true"
            [formControl]="form.controls.availableQuantity"
            [min]="0"
            placeholder="Wprowadź dostępną ilość" />
        </app-form-control>

        <app-form-control
          hint="Pozostawienie tego pola pustego oznacza brak limitu."
          label="Maksymalna ilość sztuk w zamówieniu">
          <p-input-number
            [fluid]="true"
            [formControl]="form.controls.maxQuantityPerOrder"
            [min]="1"
            placeholder="Wprowadź maksymalną ilość sztuk" />
        </app-form-control>

        @if (isEditContext()) {
          <app-form-control label="Slug">
            <input
              [formControl]="form.controls.slug"
              placeholder="Wprowadź slug"
              appPrimengInputText
              pInputText />
          </app-form-control>
        }

        <app-form-control label="Status">
          <p-select
            [formControl]="form.controls.status"
            [options]="valueOrDefault(productStatusSelectItems$ | async, [])"
            appPrimengSelect
            [fluid]="true"
            placeholder="Wybierz status" />
        </app-form-control>

        @if (shouldPasswordVisible$ | async) {
          <app-form-control label="Hasło">
            <p-password
              [fluid]="true"
              [formControl]="form.controls.password"
              appPrimengPassword
              autocomplete="off"
              placeholder="Wprowadź hasło" />
          </app-form-control>
        }

        <app-form-control
          inputId="9d8d95ae-b5aa-4ee5-bf32-c153d927fc65"
          label="Produkt wirtualny">
          <app-checkbox-with-label
            inputId="9d8d95ae-b5aa-4ee5-bf32-c153d927fc65"
            type="short">
            <p-checkbox
              [binary]="true"
              [formControl]="form.controls.virtual" />

            <span label>Produkt wirtualny</span>
          </app-checkbox-with-label>
        </app-form-control>

        <app-form-control
          hint="Przykład: pojemność, waga"
          label="Atrybuty produktu">
          <app-admin-product-attributes-control
            [formControl]="form.controls.attributes" />
        </app-form-control>

        <app-form-control
          hint="Przykład: opis, składniki"
          label="Charakterystyka produktu">
          <app-admin-product-characteristics-control
            [formControl]="form.controls.characteristics" />
        </app-form-control>
      </div>

      <div class="mt-auto flex justify-end">
        <p-button
          [disabled]="form.invalid"
          appPrimengButton
          label="Zapisz"
          severity="primary"
          type="submit" />
      </div>
    </div>
  </div>
</form>
